import React, { useState } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import CTAButton from "../buttons/CTAButton";
import NavbarDrawer from "./NavbarDrawer";
import { SECTIONS } from "../../constants/placeholder";
import Logo from "../../assets/images/logo_blue_transparent.png";
import { Typography } from "@mui/material";

function ScrollNavbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation(); // Get the current location

  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Container>
        <Toolbar disableGutters sx={{ alignItems: "center" }}>
          {/* Logo */}
          <Box variant="h4" noWrap component="a" href="/">
            <img
              src={Logo}
              alt="Renpha logo"
              loading="lazy"
              className="h-12 md:h-20"
            />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              justifyContent: "center",
              alignItems: "end",
              gap: 2,
            }}
          >
            <a
              href="#contact-us"
              class="px-6 py-2  font-medium text-white bg-primary rounded-full shadow-2xl hover:bg-primary-dark"
            >
              Get in Touch
            </a>
          </Box>

          {/* Navbar for Larger Screens */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "flex-end",
              alignItems: "end",
              gap: 2,
            }}
          >
            {SECTIONS.map((page, index) => (
              <Box key={index} display="flex" alignItems="center">
                <a href={page.to} style={{ textDecoration: "none" }}>
                  <Typography
                    variant="body2"
                    color={
                      location.pathname === page.to ? "primary" : "inherit"
                    }
                    fontWeight={location.pathname === page.to ? 600 : 400}
                  >
                    {page.text}
                  </Typography>
                </a>
              </Box>
            ))}
            {/* <CTAButton
              text="Get in Touch"
              fullWidth={false}
              bgcolor="primary.main"
              my={0}
            /> */}
            <a
              href="#contact-us"
              class="px-6 py-2  font-medium text-white bg-primary rounded-full shadow-2xl hover:bg-primary-dark"
            >
              Get in Touch
            </a>
          </Box>

          {/* Navbar Drawer for Small Screens */}
          <NavbarDrawer
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
            pages={SECTIONS}
          />
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ScrollNavbar;
